var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngageIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 120,
    viewBox: "0 0 158 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_90774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0137 0C60.8788 0 34.0098 26.8612 34.0098 60.0039C34.0098 93.1466 60.871 120.008 94.0137 120.008C117.287 120.008 137.466 106.754 147.414 87.3834H130.87L154.01 60.0039C154.018 26.8612 127.149 0 94.0137 0Z",
    fill: "#B245FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.017 60.0039L130.878 87.3833H147.422H157.661L154.017 60.0039Z",
    fill: "#B245FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.681 84.4624C130.681 94.1909 122.798 102.074 113.07 102.074C103.341 102.074 95.458 94.1909 95.458 84.4624",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1643 99.169C27.234 97.7792 23.6378 93.2173 21.6199 84.007L13.4854 46.5615L21.934 48.0377L29.032 84.4703C30.3983 90.0844 32.2827 91.3957 36.1772 92.0788C37.6455 92.3379 39.1531 92.3693 40.6763 92.3379V99.6794C39.0275 99.6165 37.4414 99.5694 35.1722 99.169",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3633 99.6794V92.3379C49.8865 92.3771 51.3941 92.3379 52.8624 92.0788C56.7569 91.3957 58.6414 90.0844 60.0076 84.4703L67.1057 48.0377L75.5543 46.5615L67.4198 84.007C65.394 93.2173 61.8057 97.7792 53.8753 99.169C51.5983 99.5694 50.02 99.6165 48.3633 99.6794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0484 44.1826H13.0215L14.4034 50.8174H74.635L76.0484 44.1826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5277 92.3379H40.4795V117.142H57.1725V111.63H48.5277V92.3379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7398 109.981H25.4199V117.134H62.7398V109.981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.924 67.6123C79.016 77.8983 73.983 81.6672 68.1648 80.9762L70.2141 70.5489L64.9219 69.6538L62.3779 83.3161C64.1132 83.7636 65.66 84.0227 66.987 84.2426C76.3857 85.8287 83.523 84.965 87.5274 68.5624L80.924 67.6045V67.6123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6831 53.5341C82.534 53.5027 82.3769 53.4791 82.2277 53.4556V55.3243H79.5895V59.2738C82.1257 60.3652 81.7723 62.9563 81.1756 66.0342L79.2676 74.051C81.1442 73.3208 84.4969 72.5748 86.3578 71.8132C86.9703 71.562 86.2008 71.3028 86.8054 71.0516L88.2187 65.6024C89.4279 59.3602 88.7291 54.704 82.6753 53.5341",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2359 53.4634H71.8086V59.2659H79.5976L84.0025 56.2822L82.2359 53.4634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12978 67.6123C10.0378 77.8983 15.0708 81.3138 20.8891 80.6229L18.8397 70.5489L24.1319 69.6538L26.6759 83.3161C24.9406 83.7636 23.3938 84.0227 22.0668 84.2426C12.6682 85.8287 5.53082 84.965 1.52637 68.5624L8.12978 67.6045V67.6123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37115 53.5341C6.52034 53.5027 6.67738 53.4791 6.81871 53.4556V55.3243H9.45693V59.2738C6.92078 60.3652 7.27412 62.9563 7.87086 66.0342L9.77886 74.051C7.91012 73.3208 4.54952 72.5748 2.68863 71.8132C2.07618 71.562 2.84567 71.3028 2.24107 71.0516L0.827738 65.6024C-0.381448 59.3602 0.317368 54.704 6.37115 53.5341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82624 53.4634H17.2457V59.2659H9.46446L5.05957 56.2822L6.82624 53.4634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0486 34.4616V15.9155H40.1104V34.4616",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5861 33.5508L27.7516 21.4668L20.0254 23.2806L22.8599 35.3646",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8022 35.4433L68.9901 23.006L61.3031 21.0352L58.1152 33.4725",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_90774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.328,
    height: 120,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngageIcon3);
export default __webpack_public_path__ + "static/media/engageIcon3.d0e790c214cba92f1c8c4a8cfff5e5a8.svg";
export { ForwardRef as ReactComponent };